import { useRef } from 'react';
import { alpha, styled } from '@mui/material/styles';
import {
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  InputAdornment,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { SearchOutlined, Notifications, Help, Settings } from '@mui/icons-material';
import Logo from '../../Components/Logo';
import AccountPopover from './AccountPopover';

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: 'auto',
  [theme.breakpoints.up('lg')]: {
    width: '100%'
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row', // Keep elements in a row
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 1)
  }
}));

export default function DashboardNavbar({ onOpenSidebar }) {
  const ref = useRef(null);
  const isSmallLaptop = useMediaQuery('(max-width: 1200px)'); // Adjust breakpoint for laptops

  return (
    <RootStyle>
      {/* This is the toolbar row */}
      <ToolbarStyle>
        {/* Show MenuIcon for laptops or smaller widths */}
        {isSmallLaptop && (
          <IconButton
            sx={{
              height: '3%',
              backgroundColor: 'White',
              '&:hover': {
                backgroundColor: '#F5F5F5'
              },
              color: 'primary.main'
            }}
            variant="text"
            onClick={onOpenSidebar}
          >
            <MenuIcon fontSize="normal" />
          </IconButton>
        )}

        {/* Conditionally render the logo */}
        {!isSmallLaptop && <Logo />}

        {/* Action Items */}
        <Stack direction="row" alignItems="center">
          {/* {!isSmallLaptop && (
            <>
              <TextField
                placeholder="Search"
                size="small"
                variant="outlined"
                sx={{
                  width: '200px',
                  '& .MuiInputBase-root': {
                    height: '40px'
                  },
                  mr: 2
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlined fontSize="small" />
                    </InputAdornment>
                  )
                }}
              />
              <IconButton>
                <Notifications fontSize="small" />
              </IconButton>
              <IconButton>
                <Help fontSize="small" />
              </IconButton>
              <IconButton>
                <Settings fontSize="small" />
              </IconButton>
            </>
          )} */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>

      {/* This is the dividing line */}
      <div
        style={{
          width: '100%',
          borderTop: '1.8px solid #EAECF0'
        }}
      />
    </RootStyle>
  );
}
